<template>
  <div>
    <div v-if="isDesktop" class="pdf-container">
      <iframe
        class="pdf-frame"
        :src="'/pdf/' + pdfName + '.pdf'"
      >
      </iframe>
    </div>

    <div v-else class="mobile-pdf-container">
      <div class="canvas-block">
        <canvas class="mobile-pdf-frame" ref="pdfCanvas"></canvas>
      </div>
      <div class="pages-block">
        <button class="canvas-button" @click="previousPage" :disabled="localCurrentPage <= 1">Previous</button>
        <button class="canvas-button" @click="nextPage" :disabled="localCurrentPage >= totalPages">Next</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    },
    pdfName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      pdf: null,
      localCurrentPage: this.currentPage
    };
  },
  mounted() {
    this.loadPdf();
  },
  computed: {
    isDesktop() {
      return window.innerWidth > 1024;
    }
  },
  methods: {
    async loadPdf() {
      const loadingTask = pdfjsLib.getDocument("/pdf/" + this.pdfName + ".pdf");
      const pdf = await loadingTask.promise;
      this.pdf = pdf;
      this.totalPages = pdf.numPages;
      this.renderPage(this.localCurrentPage);
    },
    async renderPage(pageNumber) {
      const page = await this.pdf.getPage(pageNumber);
      const canvas = this.$refs.pdfCanvas;

      const context = canvas.getContext("2d");
      const viewport = page.getViewport({ scale: 1 });

      canvas.width = viewport.width;
      canvas.height = viewport.height;

      await page.render({
        canvasContext: context,
        viewport: viewport,
      }).promise;
    },
    previousPage() {
      if (this.localCurrentPage > 1) {
        this.localCurrentPage -= 1;
        this.renderPage(this.localCurrentPage);
      }
    },
    nextPage() {
      if (this.localCurrentPage < this.totalPages) {
        this.localCurrentPage += 1;
        this.renderPage(this.localCurrentPage);
      }
    },
  },
};
</script>

<style scoped>
.pdf-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.pdf-frame {
  width: 100%;
  height: 600px;
  border: 2px solid #ddd;
  border-radius: 8px;
}

.mobile-pdf-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  flex-direction: column;
}

.canvas-block {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
}

.mobile-pdf-frame {
  border: 2px solid #ddd;
  border-radius: 8px;
  margin: 0 auto;
  width: 80%;
}

@media (max-width: 768px) {
  .mobile-pdf-frame {
    width: 100%;
  }
}

.pages-block {
  margin-top: 20px;
}

.canvas-button {
  box-shadow: 0 2px 18px 0 rgba(219, 231, 254, 0.93);
  color: #1f2427;
  font-family: "Roboto Condensed";
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 1.5px;
  line-height: 19px;
  text-align: center;
  padding: 12px 32.5px;
  border: 1px solid #ffffff;
  border-radius: 2px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  width: 145px;
}
</style>
